import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Note } from '../../../types/Note';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const postNote = async (formData: Note) => {
  const response = await CustomAxios.post(`notes`, formData);
  const { data } = response;
  return data;
};

type useCreateNoteProps = {
  onSuccessCallback: (newNote: Note) => void;
};
export function useCreateNote({ onSuccessCallback }: useCreateNoteProps) {
  return useMutation({
    mutationFn: (formData: Note) => postNote(formData),
    onSuccess: (newNote: Note) => {
      // call success
      onSuccessCallback(newNote);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        // let set the query data with bad errored response
        const note: Note = err.response.data as Note;
        queryClient.setQueryData([queryKeys.allNotes, 'new'], note);
      }
    },
  });
}
